// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".title[data-v-cb9bf35c]{font-size:36px;color:#333;text-align:center}.title img[data-v-cb9bf35c]{vertical-align:middle;margin-top:-2px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
